import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { IconService } from '../../../services/icon/icon.service';
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-svg-icon',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './svg-icon.component.html',
  styleUrl: './svg-icon.component.scss',
})
export class SvgIconComponent implements OnInit, OnChanges {
  iconHtml$: Observable<SafeHtml> | undefined;

  @Input() path = '';
  @Input() key = '';

  constructor(private iconService: IconService) {}

  /**
   * A lifecycle hook that is called when any data-bound property of a directive changes.
   * This method detects changes and triggers actions accordingly.
   * In this implementation, it directly calls the `ngOnInit` method.
   *
   * @return {void} This method does not return any value.
   */
  ngOnChanges(): void {
    this.ngOnInit();
  }

  /**
   * Initializes the component by assigning an observable stream to `iconHtml$` based on the presence of `path`.
   * If `path` is defined, it retrieves the SVG code from the icon service using the provided path.
   * Otherwise, it retrieves the SVG code using a key.
   *
   * @return {void} Does not return any value.
   */
  ngOnInit(): void {
    this.iconHtml$ = this.path
      ? this.iconService.getSvgCode(this.path)
      : this.iconService.getSvgCodeByKey(this.key);
  }
}
